import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {
        // this.$controls = this.$('controls')[0];

        this.swiper = new Swiper(this.$('slider')[0], {
            loop: true,
            slidesPerView: 1,
            loopedSlides: 5,
            centeredSlides: true,
            preloadImages: true,
            speed: 800,
            autoplay: true,
            longSwipesRatio: 0.25
        });

    }

    inview(e) {
        if(e.obj.el == this.el) {
            this.swiper.params.lazy.loadPrevNext = true;
            this.swiper.lazy.load()
            this.swiper.autoplay.start()
        }
    }

    destroy() {
        if(this.swiper !== undefined) {
            this.swiper.destroy()
        }
    }
}